import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ROWITEM } from 'src/app/app.module';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { ValidateDialogComponent } from 'src/app/dialogs/validate-dialog/validate-dialog.component';
import { CNPrescription } from 'src/app/models/cnprescription';
import { CNPrescriptionEntry } from 'src/app/models/cnprescriptionentry';
import { PrescriptionService } from 'src/app/services/prescription.service';
import { TypeManagerService } from 'src/app/services/type-manager.service';

@ManageType('PrescriptionEntryComponent')
@Component({
  selector: 'app-prescription-entry',
  templateUrl: './prescription-entry.component.html',
  styleUrls: ['./prescription-entry.component.scss']
})
export class PrescriptionEntryComponent implements OnInit {

  @Input() entry: CNPrescriptionEntry;
  @Output() removed: EventEmitter<CNPrescriptionEntry> = new EventEmitter();

  constructor(private typeManager: TypeManagerService, private prescription: PrescriptionService, private dialog: MatDialog) { }

  ngOnInit(): void {
  }

  editEntry() {
    console.log('openPrescription');
    if (this.typeManager.typeMap('PrescriptionEditDialogComponent')) {
      const componentFactory = this.typeManager.typeMap('PrescriptionEditDialogComponent');
      const dialogRef = this.dialog.open(componentFactory, {
          data: {
            entry: this.entry
          },
      });
      dialogRef.afterClosed().subscribe(result => {
        console.log('returned entry', result);
        if (result) {
          // Update entry
          this.prescription.updatePrescriptionEntry(result).subscribe(updatedEntry => {
            this.entry = updatedEntry;
          });
        }
      });
    }
  }

  removeEntry() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: 'Voulez-vous supprimer cette prescription ?',
      ok: {
        label: 'Supprimer',
        code: 'ok'
      },
      cancel: {
        label: 'Annuler',
        code: 'cancel'
      }
    };
    const dialogRef = this.dialog.open(ValidateDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'ok') {
        this.prescription.removePrescriptionEntry(this.entry).subscribe(removeresult => {
          this.removed.emit(this.entry);
        });
      }
    });
  }
}
